<footer class="w-full px-6 py-8" [style.backgroundColor]="primary()">
  @if (getFooterData()?.data; as footerData) {
  <div
    class="container max-w-[1000px] flex flex-col gap-4 justify-center mx-auto"
  >
    @if (footerData.showLogo) {
    <figure class="mx-auto">
      <img
        [src]="logoPath()"
        [alt]="logoAlt()"
        class="h-auto max-h-[21px] w-auto cursor-pointer"
      />
    </figure>
    }

    <ul
      class="flex flex-wrap gap-y-4 gap-x-2 lg:gap-y-10 lg:gap-x-10 mx-auto p-0 m-0 list-none"
    >
      @for (link of footerData.links; track link.id){
      <li>
        @if (link.urlExternal) {
        <a
          [href]="
            link.urlExternal.includes('http')
              ? link.urlExternal
              : 'https://' + link.urlExternal
          "
          target="_blank"
          class="text-xs leading-none"
          [style.color]="bgContent()"
        >
          {{ link.label }}
        </a>
        } @else {
        <a
          [routerLink]="link.urlInternal | translate"
          [target]="link.targetBlank ? '_blank' : '_self'"
          class="text-xs leading-none"
          [style.color]="bgContent()"
        >
          {{ link.label }}
        </a>
        }
      </li>
      }
    </ul>

    <a
      href="https://neopos.pl/software/eCommerce"
      class="flex gap-2.5 items-center mx-auto pt-4"
      target="_blank"
    >
      <p class="font-medium text-xs" [style.color]="bgContent()">Powered by</p>

      <figure>
        <img
          src="assets/img/logo.png"
          [alt]="'Logo' | translate"
          class="max-h-4"
        />
      </figure>
    </a>
  </div>
  }
</footer>
